<template>
  <div class="content-v2">
    <div class="staff-grid-v2">
      <router-link class="staff-item-v2" v-for="item in staffList" :key="item.id" :to="'/enterprise/staff/' + item.id">
        <img :src="item.image" :alt="item.title" />
        <span>{{ item.title }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { getCultureArticleList } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultStaffImage from '@/assets/images/staff2.svg'

export default {
  name: 'EntStaffV2',
  data() {
    return {
      staffList: Array.from({ length: 9 }).map((_, index) => ({
        id: index + 1,
        title: `员工风采 ${index + 1}`,
        image: defaultStaffImage
      }))
    }
  },
  created() {
    Promise.all([
      getCultureArticleList({ articleType: 'training', pageNum: 1, pageSize: 50 }),
      getCultureArticleList({ articleType: 'activity', pageNum: 1, pageSize: 50 })
    ]).then(([training, activity]) => {
      const rows = [...(training.rows || []), ...(activity.rows || [])]
      if (!rows.length) {
        return
      }
      this.staffList = rows.map(item => ({
        id: item.articleId,
        title: item.articleTitle,
        image: resolveFileUrl(item.coverUrl, defaultStaffImage)
      }))
    }).catch(() => {})
  }
}
</script>

<style lang="scss" scoped>
.staff-grid-v2 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.staff-item-v2 {
  border-radius: 16px;
  overflow: hidden;
  display: block;
  position: relative;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);

  img {
    width: 100%;
    display: block;
    transition: transform 0.5s;
  }

  &:hover img {
    transform: scale(1.05);
  }

  span {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 14px 16px;
    background: linear-gradient(180deg, transparent, rgba(15,23,42,0.86));
    color: #fff;
    font-size: 15px;
    font-weight: 600;
  }
}

@media (max-width: 960px) {
  .staff-grid-v2 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .staff-grid-v2 {
    grid-template-columns: 1fr;
  }
}
</style>
